import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { BnccExamPerformanceByAreaChartPresentation } from "home/components/bncc_exam"

class BnccExamPerformanceByAreaChartContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      chartPatch: null
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource("bncc_exam/performance_by_area", filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
    this.setState({
      chartPatch: response.data.patch
    })
  }

  render () {
    return <BnccExamPerformanceByAreaChartPresentation patch={this.state.chartPatch} />
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      "bnccExams/performanceByArea": state.filters["bnccExams/performanceByArea"]
    }
  }
}

export default connect(mapStateToProps)(BnccExamPerformanceByAreaChartContainer)
